<template>
  <div class="queue-work">
    <template v-if="station.id === null">
      <QueueInput v-model="stationName" label="Estação" />
      <QueueButton label="Entrar" @click="handleSubmit" />
    </template>
    <QueueButton v-else label="Chamar fila" @click="callClient" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QueueInput from '../inputs/QueueInput.vue'
import QueueButton from '../buttons/QueueButton.vue'

export default {
  name: 'QueueWork',
  components: {
    QueueInput,
    QueueButton
  },
  data () {
    return {
      stationName: ''
    }
  },
  computed: {
    ...mapGetters(['station', 'CurrentClientePreferencial', 'filaPreferencial']),
    hasPreferencialWaiting () {
      return this.CurrentClientePreferencial < this.filaPreferencial
    }
  },
  methods: {
    ...mapActions(['fetchStation', 'incrementCurrentClienteNormal', 'incrementCurrentClientePreferencial']),
    handleSubmit () {
      this.fetchStation({
        accountName: this.$route.params.account,
        stationName: this.stationName
      })
    },
    callClient () {
      if (this.hasPreferencialWaiting) {
        this.incrementCurrentClientePreferencial()
      } else {
        this.incrementCurrentClienteNormal()
      }
    }
  }
}
</script>

<style scoped>
.queue-work {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 100vh;
}
</style>
